import React from "react";
import InsertDriveFileRoundedIcon from "@mui/icons-material/InsertDriveFileRounded";
import { useSelector } from "react-redux";
import { Grid, styled } from "@mui/material";
import { useDrawingArea } from "@mui/x-charts";
import { PieChart } from "@mui/x-charts/PieChart";
import CoreCard from "../../../app/core/components/CoreCard/CoreCard";
import { t } from "i18next";

const pieParams = { height: 100, margin: { right: 5 } };

const RiepilogoDocumenti = ({ userStats, isDocStats = true }) => {
  const colorPrimary = useSelector((state) => state.app.primaryColor);

  //DATI DOC
  const totalValue = userStats.Data.totalDocuments;
  const validValue = userStats.Data.validatedDocuments;
  const pendingValue = userStats.Data.pendingDocuments;
  const rejectedValue = userStats.Data.rejectedDocuments;

  //DATI ATTIVITÀ
  const totalActivitiesValue = userStats.Data.totalPractices;
  const opened = userStats.Data.openPractices;
  const closed = userStats.Data.closedPractices;
  const wip =
    userStats.Data.inProgressPractices + userStats.Data.pendingPractices;

  const StyledText = styled("text")(({ customColor }) => ({
    fill: customColor,
    textAnchor: "middle",
    dominantBaseline: "central",
    fontSize: 28,
    fontWeight: 700,
  }));

  function PieCenterLabel({ children, customColor }) {
    const { width, height, left, top } = useDrawingArea();
    return (
      <StyledText
        customColor={customColor}
        x={left + width / 2}
        y={top + height / 2}
      >
        {children}
      </StyledText>
    );
  }

  return (
    <div className="flex flex-col  w-full">
      {isDocStats ? <h3>{t("DocsStatus")}</h3> : <h3>{t("PracticeStatus")}</h3>}
      <div className="flex justify-between w-full items-center">
        <CoreCard
          elevation={0}
          // className="ml-4"
          width={"150px"}
          height={"150px"}
          child={
            <>
              <div className="flex justify-center items-center">
                <p
                  className="text-3xl font-bold mb-3 text-white absolute"
                  style={{ color: colorPrimary }}
                >
                  {isDocStats ? totalValue : totalActivitiesValue}
                </p>
                <InsertDriveFileRoundedIcon className="fill-gray w-24 h-24" />
              </div>
              <p
                className="text-xl font-bold m-0 "
                style={{ color: colorPrimary }}
              >
                {t("Totals")}
              </p>
            </>
          }
        />

        <Grid
          width={"72%"}
          container
          justifyContent="right"
          alignItems="center"
        >
          <Grid
            item
            xs={4}
            container
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
          >
            <PieChart
              tooltip={{ trigger: "none" }}
              series={[
                {
                  data: [
                    {
                      value: isDocStats ? validValue : closed,
                      color: "#359F1C",
                    },
                    {
                      value:
                        (isDocStats
                          ? totalValue - validValue
                          : totalActivitiesValue - closed) || 1,
                      color: "#e7fbe8",
                    },
                  ],
                  innerRadius: 30,
                  outerRadius: 50,
                },
              ]}
              {...pieParams}
            >
              <PieCenterLabel customColor={"#359F1C"}>
                {isDocStats ? validValue : closed}
              </PieCenterLabel>
            </PieChart>

            <h3
              className={`mt-3 text-center leading-none`}
              style={{ color: "#359F1C" }}
            >
              {isDocStats ? t("Validateds") : t("Closeds")}
            </h3>
            {/* <Button
                                className="bg-transparent border-0 my-0 p-0 font-bold"
                                sx={{ color: colorPrimary }}
                            >
                                Visualizza
                            </Button> */}
          </Grid>

          <Grid
            item
            xs={4}
            container
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
          >
            <PieChart
              tooltip={{ trigger: "none" }}
              series={[
                {
                  data: [
                    {
                      value: isDocStats ? pendingValue : wip,
                      color: "#D86F07",
                    },
                    {
                      value:
                        (isDocStats
                          ? totalValue - pendingValue
                          : totalActivitiesValue - wip) || 1,
                      color: "#ffe4b5",
                    },
                  ],
                  innerRadius: 30,
                  outerRadius: 50,
                },
              ]}
              {...pieParams}
            >
              <PieCenterLabel customColor={"#D86F07"}>
                {isDocStats ? pendingValue : wip}
              </PieCenterLabel>
            </PieChart>

            <h3
              className={`mt-3 text-center leading-none`}
              style={{ color: "#D86F07" }}
            >
              {isDocStats ? t("ToValidate") : t("Pending")}
            </h3>
            {/* <Button
                                className="bg-transparent border-0 my-0 p-0 font-bold"
                                sx={{ color: colorPrimary }}
                            >
                                Visualizza
                            </Button> */}
          </Grid>
          <Grid
            item
            xs={4}
            container
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
          >
            <PieChart
              tooltip={{ trigger: "none" }}
              series={[
                {
                  data: [
                    {
                      value: isDocStats ? rejectedValue : opened,
                      color: "#C1272D",
                    },
                    {
                      value:
                        (isDocStats
                          ? totalValue - rejectedValue
                          : totalActivitiesValue - opened) || 1,
                      color: "mistyrose",
                    },
                  ],
                  innerRadius: 30,
                  outerRadius: 50,
                },
              ]}
              {...pieParams}
            >
              <PieCenterLabel customColor={"#C1272D"}>
                {isDocStats ? rejectedValue : opened}
              </PieCenterLabel>
            </PieChart>

            <h3
              className={`mt-3 text-center leading-none `}
              style={{ color: "#C1272D" }}
            >
              {isDocStats ? t("Discarded") : t("Opens")}
            </h3>
            {/* <Button
                                className="bg-transparent border-0 my-0 p-0 font-bold"
                                sx={{ color: colorPrimary }}
                            >
                                Visualizza
                            </Button> */}
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default RiepilogoDocumenti;
